/* unplugin-vue-components disabled */import { render } from "./node-card.vue?vue&type=template&id=4697a5c2&scoped=true"
import script from "./node-card.vue?vue&type=script&lang=js"
export * from "./node-card.vue?vue&type=script&lang=js"

import "./node-card.vue?vue&type=style&index=0&id=4697a5c2&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4697a5c2"],['__file',"src/components/widgets/org-map/node-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4697a5c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4697a5c2', __exports__)) {
    api.reload('4697a5c2', __exports__)
  }
  
  module.hot.accept("./node-card.vue?vue&type=template&id=4697a5c2&scoped=true", () => {
    api.rerender('4697a5c2', render)
  })

}


export default __exports__